import { h } from "preact";
import { Tooltip as ReactTooltip } from "react-tooltip";

/**
 * Tooltip.
 * Style has to be set, because somehow the styling over css did not really work.
 */
export default function Tooltip(props) {
  return (
    <ReactTooltip
      delayShow={500}
      {...props}
      style={{
        backgroundColor: "#484848",
        color: "#fff",
        fontSize: "0.75rem",
        padding: "0.5rem 0.75rem",
        maxWidth: "16rem",
        whiteSpace: "normal",
      }}
      opacity={1}
    />
  );
}
